
const welcomePopup = () => {
    return(
        <div className='welcome-box'>
            <i className="fa fa-solid fa-check check-icon"></i><span>{localStorage.getItem('userName')}</span> <span>عزیز خوش آمدید!</span>
        </div>
    )
}

export default welcomePopup